var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.resize),expression:"resize"}],staticClass:"marquee-background",style:({
    '--marquee-background-width': `${_vm.width}px`,
    '--marquee-background-height': `${_vm.height}px`
  })},_vm._l((_vm.isReady ? _vm.backgroundImages : []),function(backgroundImage,index){return _c('marquee',{key:backgroundImage._key,attrs:{"speed":12 + 12 * (index * -0.5)}},[_c('marquee-background-image',{attrs:{"background-image":backgroundImage}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }